export default "__VITE_ASSET__CPGnaoWE__"